import { render, staticRenderFns } from "./Paired.vue?vue&type=template&id=5f218fa4&scoped=true&"
import script from "./Paired.vue?vue&type=script&lang=js&"
export * from "./Paired.vue?vue&type=script&lang=js&"
import style0 from "./Paired.vue?vue&type=style&index=0&id=5f218fa4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f218fa4",
  null
  
)

export default component.exports